module.exports = __webpack_public_path__ + "static/media/currency-converter.fd0bba20.png";